/**
 * DPos
 * API for DPos
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ManualClosingReportRequestDto { 
    dateRangeEnd?: string;
    dateRangeStart?: string;
    emailFormats?: Array<string>;
    emailReportTypes?: Array<string>;
    exportType?: string;
    format?: string;
    merchantId?: number;
    month?: number;
    reportType?: string;
    userShiftId?: number;
    year?: number;
}

